/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NameEnum } from './NameEnum';
import { NameEnumFromJSON, NameEnumFromJSONTyped, NameEnumToJSON } from './NameEnum';

/**
 *
 * @export
 * @interface Role
 */
export interface Role {
  /**
   *
   * @type {number}
   * @memberof Role
   */
  readonly id: number;
  /**
   *
   * @type {NameEnum}
   * @memberof Role
   */
  name: NameEnum;
}

/**
 * Check if a given object implements the Role interface.
 */
export function instanceOfRole(value: object): value is Role {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  return true;
}

export function RoleFromJSON(json: any): Role {
  return RoleFromJSONTyped(json, false);
}

export function RoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Role {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: NameEnumFromJSON(json['name']),
  };
}

export function RoleToJSON(value?: Omit<Role, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: NameEnumToJSON(value['name']),
  };
}
